
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import PersonalInfoTab from './PersonalInfoTab';
import WorkExperienceTab from './WorkExperienceTab';
import EducationTab from './EducationTab';
import CertificationsTab from './CertificationsTab';
import SkillsTab from './SkillsTab';

interface ProfileTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  userId: string;
  profile: any;
  refreshTrigger: number;
  onRefresh: () => void;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ 
  activeTab, 
  setActiveTab, 
  userId, 
  profile,
  refreshTrigger,
  onRefresh
}) => {
  return (
    <Tabs defaultValue={activeTab} className="w-full" onValueChange={setActiveTab}>
      <TabsList className="bg-white/80 border border-[#0EA5E9]/20 mb-6">
        <TabsTrigger 
          value="personal" 
          className="data-[state=active]:bg-[#0EA5E9] data-[state=active]:text-white"
        >
          Personal Information
        </TabsTrigger>
        <TabsTrigger 
          value="experience" 
          className="data-[state=active]:bg-[#0EA5E9] data-[state=active]:text-white"
        >
          Work Experience
        </TabsTrigger>
        <TabsTrigger 
          value="education" 
          className="data-[state=active]:bg-[#0EA5E9] data-[state=active]:text-white"
        >
          Education
        </TabsTrigger>
        <TabsTrigger 
          value="certifications" 
          className="data-[state=active]:bg-[#0EA5E9] data-[state=active]:text-white"
        >
          Certifications
        </TabsTrigger>
        <TabsTrigger 
          value="skills" 
          className="data-[state=active]:bg-[#0EA5E9] data-[state=active]:text-white"
        >
          Skills
        </TabsTrigger>
      </TabsList>

      <TabsContent value="personal">
        <PersonalInfoTab userId={userId} profile={profile} />
      </TabsContent>

      <TabsContent value="experience">
        <WorkExperienceTab userId={userId} onRefresh={onRefresh} />
      </TabsContent>

      <TabsContent value="education">
        <EducationTab userId={userId} onRefresh={onRefresh} />
      </TabsContent>

      <TabsContent value="certifications">
        <CertificationsTab userId={userId} />
      </TabsContent>

      <TabsContent value="skills">
        <SkillsTab userId={userId} />
      </TabsContent>
    </Tabs>
  );
};

export default ProfileTabs;
